import React, {Component} from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';
import moment from 'moment';
import store from 'store';

import {
    Breadcrumb, BreadcrumbItem,
    Button,
    Card, CardBody, CardSubtitle, CardText, CardTitle,
    Col,
    Container,
    Nav, NavItem, NavLink,
    Row,
    TabContent, TabPane,
    Table
} from 'reactstrap';
import {browserHistory, Link} from 'react-router';

import {fetchListing, fetchStatus} from './actions/listings';
import PolyUtil from "../../util/PolyUtil";

import {
    handleAddToInterestList,
    handleApply,
    handleRemoveFromInterestList,
    handleWithdraw
} from "../tenant/actions/tenant";

import BasicStreetMap from "../../components/media/maps/BasicStreetMap";
import LazyImage from "../../components/media/images/LazyImage";
import StripeCheckout from "../../components/billing/StripeCheckout";
import group from "../../assets/svg/icons/np_group.svg";
import bedrooms from "../../assets/svg/icons/np_bed.svg";
import bathrooms from "../../assets/svg/icons/np_shower.svg";
import {AsyncButton} from "../../components/controls/buttons/AsyncButton";
import ReduxModalWrapper from "../../components/display/Modals/ReduxModalWrapper";
import {displayModal, hideModal} from "../../store/actions/display";
import Loader from "../../components/display/Loader";
import {setFooterVisibility, setNavbarVisibility} from "../navigation/actions/navbar";
import EditListingForm from "../owner/listings/EditListingForm";

class SingleListing extends Component {
    state = {
        activeTab: '1',
        showConfirmModal: false,
        showCheckout: false
    };

    componentWillMount() {
        // download listing if it's not already in redux store
        if (!this.props.listings[this.props.params.apply_key]) {
            this.props.getListing(this.props.params.apply_key).then(() => {
                if (store.get('type') === 'tenant') {
                    this.props.getStatus(this.props.params.apply_key);
                }
            });
        }
        else {
            this.props.getStatus(this.props.params.apply_key);
        }

        if (!store.get('type')) {
            store.set('listing', this.props.params.apply_key);
        } else {
            store.remove('listing');
        }

        this.props._setNavbarVisibility(true);
        this.props._setFooterVisibility(true);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleConfirmModal = () => {
        this.setState({showConfirmModal: !this.state.showConfirmModal});
    };

    showWithdrawModal = () => {
        const curListing = this.props.listings[this.props.params.apply_key];
        this.props._displayModal({
            id: 'confirm_application_change_modal',
            header: 'Confirm Application Withdraw',
            body: (<h4>Are you sure you want to withdraw your application from this listing?</h4>),
            footer: (
                <div>
                    <Button color="default"
                            outline
                            onClick={() => this.props._hideModal('confirm_application_change_modal')}>
                        Cancel
                    </Button>
                    {' '}
                    <AsyncButton task={() => this.props._handleWithdraw(curListing.apply_key)}
                                 color="danger"
                                 outline>
                        Withdraw Application
                    </AsyncButton>
                </div>
            )
        });
    };

    showApplyModal = () => {
        const curListing = this.props.listings[this.props.params.apply_key];
        // const {payment_method_on_file} = this.props;

        this.props._displayModal({
            id: 'confirm_application_change_modal',
            header: 'Confirm Application to ' + PolyUtil.getPropertyStreetAddress(curListing.prop),
            body: (
                <div>
                    <h4>Are you sure you want to apply to this listing?</h4>
                    <p>Applying will "lock in" your group, and cancel any pending invitations.</p>
                </div>
            ),
            footer: (
                <div>
                    <Button color="danger"
                            outline
                            onClick={() => this.props._hideModal('confirm_application_change_modal')}>
                        Cancel
                    </Button>
                    {' '}
                    <AsyncButton task={() => this.props._handleApply(curListing.apply_key)}
                                 color="success"
                                 outline>
                        Apply
                    </AsyncButton>
                </div>
            )
        });
    };

    showEditModal = () => {
        const curListing = this.props.listings[this.props.params.apply_key];
        this.props._displayModal({
            id: "edit_listing_modal_" + curListing.prop.id,
            header: "Edit Listing",
            body: (<EditListingForm propId={curListing.prop.id}/>)
        });
    };

    toggleCheckout = () => {
        this.setState({showCheckout: !this.state.showCheckout});
    };

    beginAFlow = () => {
        store.set('prop_id', this.props.listings[this.props.params.apply_key].prop.id);
        browserHistory.push('/register/');
    };

    apply = () => {
        const curListing = this.props.listings[this.props.params.apply_key];
        this.props._handleApply(curListing.apply_key);
    };

    render() {
        const curListing = this.props.listings[this.props.params.apply_key];
        const {email, isTenant, isLandlord, interest_list, _removeFromInterestList, _addToInterestList, paid} = this.props;
        if (curListing && (!isTenant || curListing.applied !== null)) {
            const has_applied = curListing.applied;
            const can_apply = curListing.availability !== undefined ? curListing.availability.can_apply : true;
            const cannot_apply_reason = curListing.availability !== undefined ? curListing.availability.reason : "";
            const roommate_group_roommate_count = this.props.roommate_group && this.props.roommate_group.roommates.length;

            let imageUrl = curListing.prop.image;
            let streetViewUrl = PolyUtil.buildStreetViewUrl(640, 426, curListing.prop.address_details.formatted_address);

            const cityState = PolyUtil.getPropertyCity(curListing.prop) + ", " + PolyUtil.getPropertyState(curListing.prop);
            const alreadyInterested = isTenant && (!!interest_list.find(function (item) {
                return item.id === curListing.prop.id;
            }));

            const interestButton = (
                isTenant ? alreadyInterested ? (
                    <AsyncButton outline
                                 color="danger"
                                 task={() => {return _removeFromInterestList(curListing.prop);}}
                                 noComplete
                                 style={{margin: "2px", flex: "1"}}>
                        Remove from Saved Properties
                    </AsyncButton>
                ) : (
                    <AsyncButton outline
                                 color="primary"
                                 task={() => {return _addToInterestList(curListing.prop);}}
                                 noComplete
                                 style={{margin: "2px", flex: "1"}}>
                        Save for Later
                    </AsyncButton>
                ) : null
            );

            const applyButton = (
                isLandlord ? (
                    <div>
                        <Button block outline color="info" onClick={this.showEditModal} style={{margin: "2px", flex: "1"}}>Edit Listing</Button>
                    </div>
                ) : has_applied ? (
                    <Button outline color="danger" onClick={this.showWithdrawModal} style={{margin: "2px", flex: "1"}}>Withdraw Application</Button>
                ) : isTenant ? (
                    <Button outline color={can_apply ? "success" : "secondary"} onClick={this.showApplyModal} disabled={!can_apply} style={{margin: "2px", flex: "1"}}>Apply Now</Button>
                ) : (
                    <Button outline color="success" onClick={this.beginAFlow} style={{margin: "2px", flex: "1"}}>Log In to Apply</Button>
                )
            );

            const returnLink = store.get('prev') === 'explore' ? (
                <Button color="link" style={{margin: '0.75rem 0 0.75rem 0', padding: '0'}} tag={Link} to="/explore" onClick={() => store.remove('prev')}>
                    <i className="fa fa-arrow-left"/> Return to Explore
                </Button>
            ) : store.get('prev') === 'dashboard' ? (
                <Button color="link" style={{margin: '0.75rem 0 0.75rem 0', padding: '0'}} tag={Link} to="/dashboard" onClick={() => store.remove('prev')}>
                    <i className="fa fa-arrow-left"/> Return to Dashboard</Button>
            ) : null;

            return (
                <div>
                    {this.state.showCheckout && <StripeCheckout email={email} onClose={this.toggleCheckout} onSuccess={() => this.props._handleApply(curListing.apply_key)}/>}
                    <Container>
                        {returnLink}
                        <Breadcrumb style={{marginTop: returnLink ? "0" : "1rem"}}>
                            <BreadcrumbItem>{cityState}</BreadcrumbItem>
                            <BreadcrumbItem active>
                                {PolyUtil.getPropertyStreetAddress(curListing.prop) + (curListing.prop.identifier ? (" (" + curListing.prop.identifier) + ")" : "")}
                            </BreadcrumbItem>
                        </Breadcrumb>
                        <Row>
                            <Col xs="12" md="8">
                                <Card style={{marginBottom: "1rem"}}>
                                    <TabContent activeTab={this.state.activeTab}>
                                        <TabPane tabId="1">
                                            <LazyImage
                                                src={imageUrl !== null ? imageUrl : streetViewUrl}
                                                className="rounded-top"
                                            />
                                        </TabPane>
                                        <TabPane tabId="2">
                                            {this.state.activeTab === '2' ? <BasicStreetMap
                                                location={curListing.prop.address_details.geometry.location}
                                                style={{paddingBottom: "66.66%"}}
                                                className="rounded-top"
                                            /> : null
                                            }
                                        </TabPane>
                                    </TabContent>
                                    <Nav>
                                        <NavItem>
                                            <NavLink
                                                tabIndex="1"
                                                className={classnames({active: this.state.activeTab === '1'})}
                                                onClick={() => {
                                                    this.toggle('1');
                                                }}
                                            >
                                                {imageUrl !== null ? "Image" : "Street View"}
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                tabIndex="2"
                                                className={classnames({active: this.state.activeTab === '2'})}
                                                onClick={() => {
                                                    this.toggle('2');
                                                }}
                                            >
                                                Map
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </Card>
                            </Col>
                            <Col xs="12" md="4">
                                <Card style={{marginBottom: "1rem"}}>
                                    <CardBody>
                                        <h3 style={{marginBottom: "0"}}>
                                            ${parseFloat(curListing.rent)} <span className="small">per month</span>
                                        </h3>
                                        <hr/>
                                        <h4 className="card-title">{PolyUtil.getPropertyStreetAddress(curListing.prop) + (curListing.prop.identifier ? (" (" + curListing.prop.identifier) + ")" : "")}</h4>
                                        <CardSubtitle>{cityState}</CardSubtitle>
                                        <hr/>
                                        <p className="text-center mb-0">
                                            <span style={{margin: "10px"}}><img src={group} width="40px" alt="Maximum Tenants"/> {curListing.prop.max_tenants}</span>
                                            <span style={{margin: "10px"}}><img src={bedrooms} width="40px" alt="Bedrooms"/> {curListing.prop.bedrooms}</span>
                                            <span style={{margin: "10px"}}><img src={bathrooms} width="40px" alt="Bathrooms"/> {parseFloat(curListing.prop.bathrooms)}</span>
                                        </p>
                                        <hr/>
                                        <div className="d-flex flex-column" style={{marginTop: ".5rem"}}>
                                            {isTenant && !has_applied &&
                                            <div>
                                                {
                                                    (
                                                        can_apply
                                                            ? <div>{
                                                                paid
                                                                    ? (<p className="text-success text-center">
                                                                        <small><i className="fa fa-check-circle"></i> You're all paid up -- applying to this listing won't cost you anything!</small>
                                                                    </p>)
                                                                    : (<p className="text-primary text-center">
                                                                        <small><i className="fa fa-info-circle"></i> Applying now will get you 30 days of <em>unlimited</em> applications to all PolyRents
                                                                            listings
                                                                        </small>
                                                                    </p>)
                                                            }</div>
                                                            : <p className="text-danger text-center">
                                                                <small><i className="fa fa-exclamation-circle"></i> {cannot_apply_reason}</small>
                                                            </p>
                                                    )
                                                }
                                            </div>
                                            }
                                            {applyButton}
                                            {interestButton}
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" lg="8">
                                <Card style={{marginBottom: "1rem"}}>
                                    <CardBody>
                                        <CardTitle>Property Details</CardTitle>
                                        <CardText style={{whiteSpace: "pre-wrap"}}>{curListing.description}</CardText>
                                        <Row>
                                            <Col md="6">
                                                <Table size="sm">
                                                    <tbody>
                                                    <tr>
                                                        <th scope="row">Rent</th>
                                                        <td>${parseFloat(curListing.rent)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Security Deposit</th>
                                                        <td>${parseFloat(curListing.security_deposit)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Lease Start</th>
                                                        <td><strong>{moment(curListing.lease_start).format('MMM DD, YYYY')}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Lease Length</th>
                                                        <td>{curListing.lease_length} mo</td>
                                                    </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                            <Col md="6">
                                                <Table size="sm">
                                                    <tbody>
                                                    <tr>
                                                        <th scope="row">Bedrooms</th>
                                                        <td>{curListing.prop.bedrooms}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Bathrooms</th>
                                                        <td>{parseFloat(curListing.prop.bathrooms)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Max Tenants</th>
                                                        <td>{curListing.prop.max_tenants}</td>
                                                    </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                        {roommate_group_roommate_count !== 0 && (curListing.prop.bedrooms > roommate_group_roommate_count) &&
                                        <Row>
                                            <Col>
                                                <p className="text-warning"><i className="fa fa-exclamation-triangle"></i>&nbsp;Head's up! This property has <strong>{curListing.prop.bedrooms}</strong>
                                                    &nbsp;bedrooms, yet you only have <strong>{roommate_group_roommate_count}</strong> {roommate_group_roommate_count === 1 ? "person" : "people"} in
                                                    your
                                                    roommate group. If you can swing the rent, awesome! Otherwise, make sure to invite your roommates to your group <em>before</em> you apply.</p>
                                            </Col>
                                        </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" lg="8">
                                <Card style={{marginBottom: "1rem"}}>
                                    <CardBody>
                                        <CardTitle>Primary Contact</CardTitle>
                                        <CardText>Questions about this listing? Contact the landlord:</CardText>
                                        <Row>
                                            <Col md="6">
                                                <Table size="sm">
                                                    <tbody>
                                                    <tr>
                                                        <th scope="row">Name</th>
                                                        <td>{curListing.prop.landlord.first_name + ' ' + curListing.prop.landlord.last_name}</td>
                                                    </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                            <Col md="6">
                                                <Table size="sm">
                                                    <tbody>
                                                    <tr>
                                                        <th scope="row">Email</th>
                                                        <td>{curListing.prop.landlord.email}</td>
                                                    </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>

                    <ReduxModalWrapper id="confirm_application_change_modal"/>
                    <ReduxModalWrapper id={"edit_listing_modal_" + curListing.prop.id}/>
                </div>
            );
        } else {
            return (
                <Loader isLoading spin/>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    email: state.activeUser && state.activeUser.email,
    listings: state.listings,
    isTenant: state.activeUser.user_type === 'tenant',
    isLandlord: state.activeUser.user_type === 'landlord',
    interest_list: state.tenant.interest_list,
    roommate_group: state.tenant.roommate_group,
    paid: state.tenant.billing.status && state.tenant.billing.status.paid,
    payment_method_on_file: state.tenant.billing && state.tenant.billing.status && state.tenant.billing.status.payment_method_on_file
});

const mapDispatchToProps = (dispatch) => {
    return {
        getListing(apply_key) {
            return dispatch(
                fetchListing(apply_key)
            );
        },
        getStatus(apply_key) {
            return dispatch(
                fetchStatus(apply_key)
            );
        },
        _addToInterestList(property) {
            return dispatch(handleAddToInterestList(property));
        },
        _removeFromInterestList(property) {
            return dispatch(handleRemoveFromInterestList(property));
        },
        _handleApply(apply_key) {
            return dispatch(handleApply(apply_key));
        },
        _handleWithdraw(apply_key) {
            return dispatch(handleWithdraw(apply_key));
        },
        _displayModal(modalData) {
            return dispatch(displayModal(modalData));
        },
        _hideModal(id) {
            return dispatch(hideModal(id));
        },
        _setNavbarVisibility(visible) {
            return dispatch(setNavbarVisibility(visible));
        },
        _setFooterVisibility(visible) {
            return dispatch(setFooterVisibility(visible));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleListing);



// WEBPACK FOOTER //
// ./src/containers/listings/SingleListing.js